import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { BreadCrumb, Loader } from '../../../../Common';
import Table from './Components/Tables/Table';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import { GET_CATEGORY, UPDATE_CATEGORY_EMPTY } from '../../../../../store/application/actionType';
import { Constant } from '../../../../Helpers/constant';
import Details from './Components/Details/Details';
import AddCategoryForm from '../AddCategory/Components/Forms/Form';
import Filter from './Components/Filters/Filter';
import CustomFilter from './Components/Filters/CustomFilter';
import LogsModal from './Components/Modals/LogsModal';
import moment from 'moment';

const ManageCategory = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [loading, setLoading] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(false);

  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);

  const [currentSelectedDetails, setCurrentSelectedDetails] = useState([]);
  const [currentConfirmationModalActionFor, setCurrentConfirmationModalActionFor] = useState(null);

  const [isListShow, setIsListShow] = useState(true);
  const [isDetailsPageShow, setIsDetailsPageShow] = useState(false);
  const [isUpdateFormShow, setIsUpdateFormShow] = useState(false);

  const [isShowLogsModal, setIsShowLogsModal] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Categories List
  const { categories, categoriesLoading } = useSelector(state => ({
    categories: state?.GetCategory?.data,
    categoriesLoading: state?.GetCategory?.loading,
  }));

  // Update Category
  const { updateCategory, updateCategoryLoading } = useSelector(state => ({
    updateCategory: state?.UpdateCategory?.data,
    updateCategoryLoading: state?.UpdateCategory?.loading,
  }));

  /* ---------------------------- DISPATCHING ---------------------------- */
  useEffect(() => {
    dispatch({
      type: GET_CATEGORY,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (updateCategory !== null) {
      dispatch({
        type: UPDATE_CATEGORY_EMPTY,
      });

      setIsListShow(true);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(false);

      let urlParams = {};
      if (currentlyAppliedFilters) {
        urlParams = {
          name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
          typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId?.data?.typeId,
          updateDate: currentlyAppliedFilters?.updateDate === `` ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
        };
      }

      dispatch({
        type: GET_CATEGORY,
        payload: {
          urlParam: {
            pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
            ...urlParams,
          },
        },
      });
    }
  }, [updateCategory]);

  /* ---------------------------- FILTER SUBMIT HANDLER ---------------------------- */
  const filterSubmitHandler = filters => {
    setIsShowFilters(false);
    setCurrentlyAppliedFilters(filters);
    setCurrentPageNumber(0);

    let urlParams = {
      name: filters?.name === `` ? null : filters?.name,
      typeId: filters?.typeId === `` ? null : filters?.typeId?.data?.typeId,
      updateDate: filters?.updateDate === `` ? null : moment(new Date(filters?.updateDate)).format('YYYY-MM-DD'),
    };

    dispatch({
      type: GET_CATEGORY,
      payload: {
        urlParam: {
          pageIndex: 0,
          ...urlParams,
        },
      },
    });
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    setCurrentPageNumber(pageNumber);

    let urlParams = {};
    if (currentlyAppliedFilters) {
      urlParams = {
        name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
        typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId?.data?.typeId,
        updateDate: currentlyAppliedFilters?.updateDate ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
      };
    }

    dispatch({
      type: GET_CATEGORY,
      payload: {
        urlParam: {
          pageIndex: pageNumber * Constant.TABLE_PAGE_SIZE,
          ...urlParams,
        },
        pagination: true,
      },
    });
  };

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    setCurrentSelectedDetails(params?.details);
    setCurrentConfirmationModalActionFor(params?.actionType);

    if (params?.actionType === `INFO`) {
      setIsListShow(false);
      setIsDetailsPageShow(true);
      setIsUpdateFormShow(false);
    } else if (params?.actionType === `UPDATE`) {
      setIsListShow(false);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(true);
    } else if (params?.actionType === `LOGS`) {
      setIsShowLogsModal(true);
    }
  };

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push('/dashboard');
    } else if (title === `Category`) {
      setIsListShow(true);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(false);

      let urlParams = {};
      if (currentlyAppliedFilters) {
        urlParams = {
          name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
          typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId?.data?.typeId,
          updateDate: currentlyAppliedFilters?.updateDate === `` ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
        };
      }

      dispatch({
        type: GET_CATEGORY,
        payload: {
          urlParam: {
            pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
            ...urlParams,
          },
          pagination: true,
        },
      });
    } else if (title === `Details`) {
      // do nothing
    } else if (title === `Update Details`) {
      // do nothing
    }
  };

  /* ---------------------------- LOADING HANDLER ---------------------------- */
  useEffect(() => {
    if (categoriesLoading || updateCategoryLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [categoriesLoading, updateCategoryLoading]);

  return (
    <>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid className="position-relative">
          {/*  ----------------------------  MODAL'S ---------------------------- */}
          {isShowLogsModal && <LogsModal data={currentSelectedDetails} onCloseHandler={() => setIsShowLogsModal(false)} />}

          {/*  ----------------------------  UI'S ---------------------------- */}
          {isListShow && (
            <>
              <BreadCrumb title="Category" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Category']} />
              {/* <Filter
                filterHandler={filterSubmitHandler}
                appliedFilters={currentlyAppliedFilters}
              /> */}

              <CustomFilter
                filterHandler={filterSubmitHandler}
                appliedFilters={currentlyAppliedFilters}
                show={isShowFilters}
                onCloseClick={() => setIsShowFilters(false)}
              />

              <Table
                title={`Category's Data`}
                data={categories?.results}
                totalData={categories?.count}
                pageHandler={paginationHandler}
                pageNumber={currentPageNumber}
                actionHandler={tableActionHandler}
                isShowFilterBtn={true}
                filterBtnHandler={() => {
                  setIsShowFilters(true);
                }}
              />
            </>
          )}

          {isDetailsPageShow && (
            <>
              <BreadCrumb title="Category" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Category', 'Details']} />
              <Details details={currentSelectedDetails} />
            </>
          )}

          {isUpdateFormShow && (
            <>
              <BreadCrumb title="Category" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Category', 'Update Details']} />

              <AddCategoryForm data={currentSelectedDetails} title="Update Category" />
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default ManageCategory;
